// src/components/Router.js
import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

// Layout
import MainLayout from "../layout/MainLayout";

// Views 
import Visita from "../views/Visita";
//import Visita from "../pages/Visita";
import App from "../App";
import Areas from "./Areas";
import Quienes from "../views/Quienes";
import Conexion from "../views/Conexion";
import Galeria from "../views/Galeria";
import Eventos from "../views/Eventos";
import Transparencia from "../views/Transparencia";
import Rubros from "./Rubros";
import DetalleRubro from "../views/DetalleRubro";
import Detalle70 from "../views/Detalle70";
import Reservaciones from "../views/Reservaciones";
import Contabilidad from "../Contabilidad/Contabilidad.js";
//import Contabilidad from "../views/Contabilidad.js";
import Detalle from "../views/Detalle";
import Licitaciones from "../views/Licitaciones";
import Designacion from "../views/Designacion";
import Rompecabezas from "../views/Rompecabezas";
import Frase from "../views/Frase";
import Simon from "../views/Simon";
import Crucigrama from "../views/Crucigrama";
import Juego from "../views/Juego";
import Mapa from "../views/Mapa";
import creatividad from "../views/creatividad";
import Archivos from "../views/Archivos";
import Palabra from "../views/Palabra";
import Tetris from "../views/Tetris";
import Sumo from "../views/Sumo";
import Fisica from "../views/Fisica";
import DiaIntegridad from "../views/DiaIntegridad";
import CCI2025 from "../views/CCI2025";
import Simulacro2025 from "../views/Simulacro2025";
import NochesTerror from "../views/NochesTerror";
import FestivalSE from "../views/FestivalSE";
import DiaInterCC from "../views/DiaInterCC";
import DK from "../views/DK";
import SMK from "../views/SMK";
import Terror from "../views/Terror";
import Nochesdeterror from "../views/Nochesdeterror";
import DinoIluminado from "../views/DinoIluminado";
import SalaVR from "../views/Salarv";
import DinosMecatronicos from "../views/DinosMecatronicos";
import DinoIluminadoBlog from "../views/DinoIluminadoBlog";
import NuevaSalaRV from "../views/NuevaSalaRV";
import ConsejoEnero from "../views/ConsejoEnero";
import ScrollToTop from "./ScrollToTop.js";
import Acerca from "../views/Acerca";
import AdecuacionesPAAS2025 from "../views/AdecuacionesPAAS25.js";



class Router2 extends Component {
  renderWithLayout = (ComponentToRender) => () => (
    <MainLayout>
      <ComponentToRender />
    </MainLayout>
  );

  render() {
    return (
      <Router>
        <ScrollToTop />
        <Switch>
        <Route exact path="/" render={this.renderWithLayout(App)} />
        <Route path="/app" render={this.renderWithLayout(App)} />
        <Route exact path="/areasyservicios" render={this.renderWithLayout(Areas)} />
        <Route path="/quienes" render={this.renderWithLayout(Quienes)} />
        <Route path="/areas/:label/:position" render={this.renderWithLayout(Conexion)} />
        <Route path="/galeria" render={this.renderWithLayout(Galeria)} />
        <Route path="/blog" render={this.renderWithLayout(Eventos)} />
        <Route exact path="/transparencia" render={this.renderWithLayout(Transparencia)} />
        <Route exact path="/rubros" render={this.renderWithLayout(Rubros)} />
        <Route path="/rubro/:posicion" render={this.renderWithLayout(DetalleRubro)} />
        <Route path="/rubro70" render={this.renderWithLayout(Detalle70)} />
        <Route path="/reservaciones" render={this.renderWithLayout(Reservaciones)} />
        <Route path="/visita" render={this.renderWithLayout(Visita)} />
        <Route exact path="/transparencia/contabilidad" render={this.renderWithLayout(Contabilidad)} />
        <Route exact path="/transparencia/contabilidad/:rubro/:posicion1" render={this.renderWithLayout(Detalle)} />
        <Route exact path="/transparencia/licitaciones" render={this.renderWithLayout(Licitaciones)} />
        <Route exact path="/transparencia/designacion" render={this.renderWithLayout(Designacion)} />
        <Route path="/juego" render={this.renderWithLayout(Juego)} />
        <Route path="/rompecabezas" render={this.renderWithLayout(Rompecabezas)} />
        <Route path="/frase" render={this.renderWithLayout(Frase)} />
        <Route path="/simon" render={this.renderWithLayout(Simon)} />
        <Route path="/crucigrama" render={this.renderWithLayout(Crucigrama)} />
        <Route path="/mapa" render={this.renderWithLayout(Mapa)} />
        <Route path="/creatividad" render={this.renderWithLayout(creatividad)} />
        <Route exact path="/transparencia/Archivos" render={this.renderWithLayout(Archivos)} />
        <Route path="/palabra" render={this.renderWithLayout(Palabra)} />
        <Route path="/tetris" render={this.renderWithLayout(Tetris)} />
        <Route path="/sumo" render={this.renderWithLayout(Sumo)} />
        <Route path="/fisica" render={this.renderWithLayout(Fisica)} />
        <Route path="/nochesterror" render={this.renderWithLayout(NochesTerror)} />
        <Route path="/cci2025" render={this.renderWithLayout(CCI2025)} />
        <Route path="/simulacro2025" render={this.renderWithLayout(Simulacro2025)} />
        <Route path="/diaintegridad" render={this.renderWithLayout(DiaIntegridad)} />
        <Route path="/festivalse" render={this.renderWithLayout(FestivalSE)} />
        <Route path="/diaintercc" render={this.renderWithLayout(DiaInterCC)} />
        <Route path="/dk" render={this.renderWithLayout(DK)} />
        <Route path="/smk" render={this.renderWithLayout(SMK)} />
        <Route path="/terror" render={this.renderWithLayout(Terror)} />
        <Route path="/nochesdeterror" render={this.renderWithLayout(Nochesdeterror)} />
        <Route path="/dinoiluminado" render={this.renderWithLayout(DinoIluminado)} />
        <Route path="/salavr" render={this.renderWithLayout(SalaVR)} />
        <Route path="/dinoparqueiluminado" render={this.renderWithLayout(DinoIluminadoBlog)} />
        <Route path="/dinosanimatronicos" render={this.renderWithLayout(DinosMecatronicos)} />
        <Route path="/nuevasalarv" render={this.renderWithLayout(NuevaSalaRV)} />
        <Route path="/consejoenero" render={this.renderWithLayout(ConsejoEnero)} />
        <Route path="/acerca" render={this.renderWithLayout(Acerca)} />
        <Route path="/adecuaciones2025" render={this.renderWithLayout(AdecuacionesPAAS2025)} />
        </Switch>
      </Router>
    );
  }
}

export default Router2;
